import React, { useState } from 'react';
import axios from 'axios';

const UpdateKills = () => {
  const [email, setEmail] = useState('');
  const [kills, setKills] = useState('');
  const [action, setAction] = useState('add'); // default action
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://backend.aubattle.com/api/admin/update-kills', {
        email,
        kills,
        action,
      });
      setMessage(res.data.message);
    } catch (err) {
      console.error(err);
      setMessage('Error updating kills');
    }
  };

  return (
    <div className="p-6 border rounded bg-white max-w-md mx-auto mt-6 shadow">
      <h2 className="text-xl font-bold mb-4 text-center">Update Total Kills</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="User Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-3 p-2 border rounded"
          required
        />
        {action !== 'delete' && (
          <input
            type="number"
            placeholder="Kills"
            value={kills}
            onChange={(e) => setKills(e.target.value)}
            className="w-full mb-3 p-2 border rounded"
            required
          />
        )}
        <select
          value={action}
          onChange={(e) => setAction(e.target.value)}
          className="w-full mb-4 p-2 border rounded"
        >
          <option value="add">Add</option>
          <option value="edit">Edit (Overwrite)</option>
          <option value="delete">Delete (Reset to 0)</option>
        </select>
        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white w-full py-2 rounded font-semibold"
        >
          Submit
        </button>
      </form>
      {message && (
        <p className="mt-4 text-center font-medium text-green-600">{message}</p>
      )}
    </div>
  );
};

export default UpdateKills;
